import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { isElectronTencentDocsClient, isTencentDocsApp } from '@tencent/docs-user-agent/pure';
import { network } from '@tencent/netcheck';
import { DriveDataApiManager } from "../../data-source/drive-data-db";
import { isSecretId } from "../../data-source/drive-data-db/utils";
import { RetCode } from "../../data-source/network-request";
import { Backend } from "../../types/backend";
export var offlineForFetchFileInfo = function offlineForFetchFileInfo(fn) {
  return new Proxy(fn, {
    apply: function apply(target, thisArg, args) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _req$objKey;
        var attr, _args, req, fileId, secretId, objKey, options, isOffline, driveDataApi, _result, result, _fileId, _driveData$fileInfo$f, _driveData$fileInfo$f2, driveId, driveData, thumbnailUrl;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              attr = 'fileInfo';
              _args = _slicedToArray(args, 1), req = _args[0];
              objKey = (_req$objKey = req.objKey) !== null && _req$objKey !== void 0 ? _req$objKey : '';
              if (isSecretId(req.fileId, !!req.objKey)) secretId = req.fileId;else fileId = req.fileId;
              options = secretId ? {
                secretId: secretId
              } : {
                driveId: "".concat(fileId, "$").concat(objKey)
              };
              isOffline = !network.isOnline;
              driveDataApi = DriveDataApiManager.getInstance().getDriveDataApi();
              if (!isOffline) {
                _context.next = 14;
                break;
              }
              _context.next = 10;
              return driveDataApi.getCacheDriveData(options);
            case 10:
              _result = _context.sent;
              if (!(_result !== null && _result !== void 0 && _result[attr])) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", {
                data: {
                  result: _result[attr],
                  retcode: RetCode.Success,
                  msg: ''
                },
                status: 200,
                statusText: 'success'
              });
            case 13:
              return _context.abrupt("return", {
                data: {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-expect-error
                  result: null,
                  retcode: Backend.RetCode.PREVIEW_FAIL,
                  msg: ''
                },
                status: 200,
                statusText: 'success'
              });
            case 14:
              _context.next = 16;
              return target.apply(thisArg, args);
            case 16:
              result = _context.sent;
              if (result.data.retcode === Backend.RetCode.SUCCESS) {
                fileId = (_fileId = fileId) !== null && _fileId !== void 0 ? _fileId : result.data.result.fileMeta.fileId;
                driveId = "".concat(fileId, "$").concat(objKey);
                driveData = _defineProperty({
                  driveId: driveId,
                  fileId: fileId,
                  objKey: objKey,
                  secretId: secretId
                }, attr, result.data.result);
                thumbnailUrl = (_driveData$fileInfo$f = (_driveData$fileInfo$f2 = driveData.fileInfo.fileMeta) === null || _driveData$fileInfo$f2 === void 0 ? void 0 : _driveData$fileInfo$f2.thumbnailUrl) !== null && _driveData$fileInfo$f !== void 0 ? _driveData$fileInfo$f : '';
                if (thumbnailUrl && (isElectronTencentDocsClient() || isTencentDocsApp())) {
                  void driveDataApi.addUriToPWA([thumbnailUrl]);
                }

                // 在线情况下，避免让用户等，数据库写入操作await
                void driveDataApi.updateCacheDriveData(driveData);
              }
              return _context.abrupt("return", result);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  });
};
//# sourceMappingURL=drive-data-offline-file-info.js.map